import {
  EventRegistrationScope,
  L3ServiceViewModel,
  MaintenanceUpdate,
  NetworkServiceUpdateEvent,
  NotificationUpdate,
  StatusUpdate,
} from '../../model';

export const parseUpdateEvent = (eventData: string): NetworkServiceUpdateEvent[] | null => {
  try {
    return JSON.parse(eventData);
  } catch (e) {
    console.error('There was a problem during parsing service update event: ', eventData);
    return null;
  }
};

export const updateServices = (services: L3ServiceViewModel[], events: NetworkServiceUpdateEvent[] | null): L3ServiceViewModel[] => {
  if (!events) {
    return services;
  }
  events?.forEach(event => {
    const service = services.find(service => event.networkServiceId === service.itemId);
    if (service) {
      event.scopeUpdates.forEach((update) => {
        if (update.scope === EventRegistrationScope.Notification) {
          service.notificationsQuantity = (update.content as NotificationUpdate).count;
        } else if (update.scope === EventRegistrationScope.Status) {
          service.status = (update.content as StatusUpdate).status;
        } else if (update.scope === EventRegistrationScope.Maintenance) {
          service.maintenanceWorks = (update.content as MaintenanceUpdate).maintenanceWorks;
        }
      });
    } else {
      console.warn('There was a trial for update non-observed service with ID: ', event.networkServiceId);
    }
  });
  return [...services];
};
